<div class="min-h-screen bg-white font-inter text-slate-950">
  <div class="flex min-h-screen flex-col items-center justify-center gap-8 px-6 py-12">
    <img
      src="assets/brand/logo.svg"
      width="48"
      height="48"
      alt="FormOps logo"
      class="h-12 w-12 rounded-2xl bg-white p-1.5 shadow-lg shadow-black/10" />

    @if (authState.loading()) {
      <p class="text-body1 text-slate-600">Completing Google sign-in...</p>
    } @else if (authState.error()) {
      <div class="flex flex-col items-center gap-4">
        <p class="text-body1 text-slate-600">Something went wrong.</p>
        <a routerLink="/signup" class="text-body2 font-medium text-primary-600 hover:text-primary-700">
          Back to signup
        </a>
      </div>
    }
  </div>
</div>
